import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useFieldArray, Controller } from "react-hook-form";
import {  Box } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import dayjs from "dayjs";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {Row, Col} from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import { costWeightChange} from "../../../utils/globalMethods";


const ShareNestedFieldArray = ({ getValues,setValue,nestIndex, watch, control, register, setPreCalc, setIsShareRowEdit, setIsDaily,isDaily, triggerPrecal }) => { 
    const [isEditing, setIsEditing] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState("");
    // eslint-disable-next-line no-unused-vars
    const w = watch();

    const { fields, remove, append } = useFieldArray({
        control,
        name: `share.${nestIndex}.nestedArray`
    });
   
    const onChangeEdit = (e,item,k, isUndoChange) =>{
        if (!isUndoChange) {
            setIsEditing((prevState)=>({
                ...prevState,
                [nestIndex+k] : true
            }));
            let editInfo = {};
            if (isEditing) {
                editInfo = isEditing;
                editInfo[nestIndex+k] = true;
            } else {
                editInfo[nestIndex+k] = true;
            }
            setIsShareRowEdit(editInfo);
            // setIsShowPrecalButton((prevState)=>({
            //     ...prevState,
            //     [nestIndex] : false
            // }));
        } else {
            setIsEditing((prevState)=>({
                ...prevState,
                [nestIndex+k] : false
            }));
            let editInfo = {};
            if (isEditing) {
                editInfo = isEditing;
                editInfo[nestIndex+k] = false;
            } else {
                editInfo[nestIndex+k] = false;
            }
            setIsShareRowEdit(editInfo);
            setIsShareRowEdit(isEditing);
            setValue(`share.${nestIndex}.nestedArray.${k}.cost`, item?.cost);
            setValue(`share.${nestIndex}.nestedArray.${k}.type`, item?.type);
            setValue(`share.${nestIndex}.nestedArray.${k}.startDate`, item?.startDate);
            setValue(`share.${nestIndex}.nestedArray.${k}.endDate`, item?.endDate);
            // setIsShowPrecalButton((prevState)=>({
            //     ...prevState,
            //     [nestIndex] : true
            // }));
            triggerPrecal({id: item.shareId});
        } 
    };

    function getAllMonthYear(startDate, endDate) {
        // const date = new Date(startDate.getTime()); 
        // const dates=[];     
        // while (date <= endDate) {
        //   dates.push(dayjs(date,"YYYY-MM-DD").format("MM/YYYY"));
        // }      
        // return dates;
        const betweenMonths = [];
        if (startDate <= endDate){
            var date = startDate.startOf('month');
         
            while (date < endDate.endOf('month')) {
               betweenMonths.push(date.format('YYYY-MM'));
               date.add(1,'month');
            }
        }
        return betweenMonths;
    }

    
    const onChangeSave = (e,item,k) =>{
        const shares = getValues()?.['share'];
        const dailyShare = shares?.find(data=>data.id==item.shareId)?.nestedArray?.filter(share=>share.type=="1");
        if (dailyShare && dailyShare.length) {
            const dates = dailyShare.map(e=>e.endDate);
            const isDuplicateDate = new Set(dates.map(v => v));
            if (isDuplicateDate.size < dates.length) {
                setIsError(true);
                setErrMsg("Selected date already exist. Please select other date");
                return;
            } else {
                setIsError(false);
                setErrMsg("");
            }
        }

        const mnthlyShare = shares?.find(data=>data.id==item.shareId)?.nestedArray?.filter(share=>share.type=="2");
        if (mnthlyShare && mnthlyShare.length) {
            const allDates = [];  

            mnthlyShare.map((data)=>{
                const d1 = moment(dayjs(data.startDate, "MM/DD/YYYY").startOf('month').format("YYYY-MM-DD"));
                const d2 = moment(dayjs(data.endDate, "MM/DD/YYYY").endOf('month').format("YYYY-MM-DD"));
                
                const dates = getAllMonthYear(d1, d2);
                if (dates && dates.length) {
                    dates.map(dat =>allDates.push(dat));
                }
                return data;
            });
            const currentMonthStart = moment().startOf('month');
            const currentMonthEnd = moment().endOf('month');

             // Check if any date is within the current month
            const isDatesInCurrentMonth = allDates.some(date => {
                const d = moment(date, "YYYY-MM-DD");
                return d.isSameOrBefore(currentMonthEnd) && d.isSameOrAfter(currentMonthStart);
            });
            const isDuplicateMonth = new Set(allDates.map(v => v));
            if (isDuplicateMonth.size < allDates.length) {
                setIsError(true);
                setErrMsg("Selected month already exist. Please select other month");
                return;
            } else if (isDatesInCurrentMonth) {
                setIsError(true);
                setErrMsg("Selected month is not valid. Please select other month");
                return;
            }
            else {
                setIsError(false);
                setIsDaily(false);
                setErrMsg("");
            }
        }

        setIsEditing((prevState)=>({
            ...prevState,
            [nestIndex+k] : false
        }));
        setPreCalc(getValues(`share.${nestIndex}.nestedArray.${k}`));
        let editInfo = {};
        if (isEditing) {
            editInfo = isEditing;
            editInfo[nestIndex+k] = false;
        } else {
            editInfo[nestIndex+k] = false;
        }
        setIsShareRowEdit(editInfo);
        triggerPrecal({id: item.shareId});
    }

    useEffect(()=>{
        register('share');
    },[register]);

    const handleFrequery = (e,k)=>{
        setValue(`share.${nestIndex}.nestedArray.${k}.type`, e.target.value);
        if (e.target.value == 1) { 
            const currentDate = new Date();
            setValue(`share.${nestIndex}.nestedArray.${k}.startDate`,dayjs(currentDate).format("MM/DD/YYYY"));
            setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,dayjs(currentDate).format("MM/DD/YYYY"));
        } else {
            const endDt = getValues(`share.${nestIndex}.nestedArray.${k}.endDate`);
            const startDt = getValues(`share.${nestIndex}.nestedArray.${k}.startDate`);
            setValue(`share.${nestIndex}.nestedArray.${k}.startDate`,dayjs(startDt).startOf('month').format("MM/DD/YYYY"));
            setValue(`share.${nestIndex}.nestedArray.${k}.endDate`, dayjs(endDt).endOf('month').format('MM/DD/YYYY'));
        }
    }
    const dailyShareValidation = (item) => {
        const shares = getValues()?.['share'];
        const dailyShare = shares?.find(data=>data.id==item.shareId)?.nestedArray?.filter(share=>share.type=="1");
        const mnthlyShare = shares?.find(data=>data.id==item.shareId)?.nestedArray?.filter(share=>share.type=="2");
        if (mnthlyShare && mnthlyShare.length) {
            const allDates = [];  

            mnthlyShare.map((data)=>{
                const d1 = moment(dayjs(data.startDate, "MM/DD/YYYY").startOf('month').format("YYYY-MM-DD"));
                const d2 = moment(dayjs(data.endDate, "MM/DD/YYYY").endOf('month').format("YYYY-MM-DD"));
                
                const dates = getAllMonthYear(d1, d2);
                if (dates && dates.length) {
                    dates.map(dat =>allDates.push(dat));
                }
                return data;
            });

            const isDuplicateMonth = new Set(allDates.map(v => v));
            if (isDuplicateMonth.size < allDates.length) {
                setIsError(true);
                setIsDaily(true);
                setErrMsg("Selected month already exist. Please select other month");
                return;
            } 
       else if(dailyShare && dailyShare.length > 1) {
            setIsError(true);
            setErrMsg("Selected date already exist. Please select other date");
            setIsDaily(true);
        } else {
            setIsDaily(false);
            setIsError(false);
            
        }
    }
    }

    const appendShare = (item) => {
        const shares = getValues()?.['share'];
        
        const dailyShare = shares?.find(data=>data.id==item.shareId)?.nestedArray?.filter(share=>share.type=="1");
        let currentDate = dayjs();

        const dateNew = dayjs(currentDate).format('MM/DD/YYYY');
        if (dailyShare && dailyShare.length) {
        const dates = dailyShare.map(e=>e.endDate);
        const datesArray = dates.map((element) => new Date(dayjs(element,'MM/DD/YYYY').format("YYYY-MM-DD")));
        const maxDate = new Date(Math.max(...datesArray));
        const date = dayjs(maxDate).add(1, 'day').format('MM/DD/YYYY');
        append({ shareId: item.shareId, cost: item.cost, type: item.isDisableDaily ? (item.isDisableMonth ? 1 : 2) : 1, 
             maxDate: item.maxDate, minDate: item.minDate, 
            startDate: item.isDisableDaily ? date : dateNew, endDate: item.isDisableDaily ? date : dateNew , 
            isDisableDaily: item.isDisableDaily, isDisableMonth: item.isDisableMonth})
        } else {
            append({ shareId: item.shareId, cost: item.cost, type: item.isDisableDaily ? (item.isDisableMonth ? 1 : 2) : 1, 
                maxDate: item.isDisableDaily ? item.maxDate : item.endDate, 
                minDate: item.isDisableDaily ? item.minDate : item.startDate, startDate: item.isDisableDaily ? item.startDate : dateNew, 
                endDate: item.isDisableDaily ? item.endDate : dateNew , 
                isDisableDaily: item.isDisableDaily , isDisableMonth: item.isDisableMonth});
        }
        triggerPrecal({id: item.shareId});
}



    return (
        <Box>
            {isError && (<span className='dh-txt-danger' style={{marginTop: '5px', marginBottom: '5px' }}>
                <i className="fa fa-info-circle"></i> {errMsg}
            </span>)}
            {fields.map((item, k) => { 
                return (
                    <div className="form-block" key={item.id}>
                        <Row xs={12}>
                            <Col md={5} xs={12} lg={4} xl={2}> 
                                <TextField className="hidesnap" sx={{ width: '70px' }} {...register(`share.${nestIndex}.nam`)} defaultValue={item.nam}/>
                                <TextField className="hidesnap" sx={{ width: '70px' }} {...register(`share.${nestIndex}.dsc`)} defaultValue={item.dsc}/>
                                <TextField className="hidesnap" sx={{ width: '70px' }} {...register(`share.${nestIndex}.shareId`)} defaultValue={item.shareId}/>
                                <Form.Group as={Col} controlId="cost">
                                    <Form.Label className="smallTitle">Cost 
                                    <span className="sr-only">required</span><span aria-hidden="true">*</span>
                                    </Form.Label>
                                    <Form.Control className="formcontrol-year" size="md" 
                                        {...register(`share.${nestIndex}.nestedArray.${k}.cost`,
                                        { required: true })} 
                                        // defaultValue={getValues(`share.${nestIndex}.nestedArray.${k}.cost`)}
                                        onKeyDown={(e) => {
                                        const value = e.target.value;
                                        const maxLength = 15; 
                                        const decimalIndex = value.indexOf('.');
                                        const decimalLength = decimalIndex === -1 ? 0 : value.length - decimalIndex - 1;
                                        if (decimalIndex !== -1 && e.key === '.') {
                                            e.preventDefault();
                                        }
                                        if ((value.replace('.', '').length >= maxLength || decimalLength >= 2) && e.key !== 'Backspace' && e.key !== '.') {
                                            e.preventDefault(); 
                                        }
                                        if (decimalIndex === -1 && value.length >= 12 && e.key !== 'Backspace' && e.key !== '.') {
                                            e.preventDefault(); 
                                        }
                                        }}
                                        onChange={(e) =>{
                                            costWeightChange(e);setValue(`share.${nestIndex}.nestedArray.${k}.cost`, e.target.value, { shouldValidate: true });}}
                                      disabled={!isEditing?.[nestIndex+k]} 
                                      />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter Cost.
                                    </Form.Control.Feedback>                                  
                                </Form.Group>
                            </Col>
                            <Col md={5} xs={12} lg={4} xl={2}> 
                                <Form.Group as={Col} controlId="frequency">
                                    <Form.Label className="smallTitle">Frequency 
                                    <span className="sr-only">required</span><span aria-hidden="true">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        disabled={!isEditing?.[nestIndex+k] || getValues(`share.${nestIndex}.nestedArray.${k}.isDisableMonth`) ||getValues(`share.${nestIndex}.nestedArray.${k}.isDisableDaily`)}
                                        defaultValue={getValues(`share.${nestIndex}.nestedArray.${k}.isDisableMonth`) ? 1 : 2}
                                        className="form-control"
                                        autocomplete="off"
                                        {...register(`share.${nestIndex}.nestedArray.${k}.type`, { required: true })}
                                        onChange={(e) =>handleFrequery(e,k)}
                                    >

                                        {getValues(`share.${nestIndex}.nestedArray.${k}.isDisableMonth`) ? (
                                            <option value={1}>Daily</option>
                                            ) : getValues(`share.${nestIndex}.nestedArray.${k}.isDisableDaily`) ? (
                                            <option value={2}>Monthly</option>
                                            ) : (
                                            <>
                                                <option value={1}>Daily</option>
                                                <option value={2}>Monthly</option>
                                            </>
                                        )}
                                       
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={5} xs={12} lg={4} xl={isEditing?.[nestIndex+k] ? 3 :2}> 
                                <Form.Group as={Col} controlId="startDate">
                                    <Form.Label className="smallTitle">Start Duration <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                    {isEditing?.[nestIndex+k] ?(
                                        <LocalizationProvider dateAdapter={AdapterDayjs} disabled={!isEditing?.[nestIndex+k]} sx={{"&.MuiStack-root": { paddingTop: "0 !important"}}}>
                                                <DemoContainer components={['DatePicker']} sx={{"& .MuiTextField-root": { minWidth: "130px !important"}, 
                                                "&.MuiStack-root": { paddingTop: "0 !important", overflow:"hidden" },
                                               }}>

                                                <Controller
                                                    control={control}
                                                    name={`share.${nestIndex}.nestedArray.${k}.startDate`}
                                                    {...register(`share.${nestIndex}.nestedArray.${k}.startDate`, { required: true })}
                                                    onChange={(date) => {
                                                        if (getValues(`share.${nestIndex}.nestedArray.${k}.type`) == 1) {
                                                            const currentDate = new Date();
                                                                    setValue(`share.${nestIndex}.nestedArray.${k}.startDate`,dayjs(currentDate).format("MM/DD/YYYY"));
                                                                    setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,dayjs(currentDate).format("MM/DD/YYYY"));
                                                        } else {
                                                            setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,dayjs(date).endOf('month').format("MM/DD/YYYY"));
                                                        }
                                                    }}
                                                    render={({ field }) => (
                                                        <DatePicker
                                                            
                                                            slotProps={{
                                                                textField: {
                                                                    readOnly: true,
                                                                },
                                                            }}                                                          
                                                            name={`share.${nestIndex}.nestedArray.${k}.startDate`}
                                                            refs={register(`share.${nestIndex}.nestedArray.${k}.startDate`, { required: true })}
                                                            views={getValues(`share.${nestIndex}.nestedArray.${k}.type`) == 1 ? ['month','day','year'] : ['month', 'year']}
                                                            minDate = {dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.minDate`))}
                                                            maxDate = {dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.maxDate`))}
                                                            defaultValue={dayjs(item?.startDate)}
                                                            disabled= {getValues(`share.${nestIndex}.nestedArray.${k}.type`) ==1}
                                                            selected={getValues(`share.${nestIndex}.nestedArray.${k}.startDate`)}
                                                            value={getValues(`share.${nestIndex}.nestedArray.${k}.type`) ==1 ? dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.startDate`)) : dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.startDate`)).startOf('month')}
                                                            onChange={(date) => {
                                                                field.onChange(dayjs(date).format("MM/DD/YYYY"))
                                                                if (getValues(`share.${nestIndex}.nestedArray.${k}.type`) ==1) {
                                                                    const currentDate = new Date();
                                                                    setValue(`share.${nestIndex}.nestedArray.${k}.startDate`,dayjs(currentDate).format("MM/DD/YYYY"));
                                                                    setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,dayjs(currentDate).format("MM/DD/YYYY"));
                                                                } else {
                                                                    if (dayjs(date) > dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.endDate`))) {
                                                                        setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,dayjs(date).endOf('month').format("MM/DD/YYYY"));
                                                                    }
                                                                }
                                                            }}
                                                            sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { padding:"9.5px 12px !important" }}}
                                                        />
                                                    )}
                                                />
                                                </DemoContainer>
                                        </LocalizationProvider> ) : 
                                        <Form.Control type="text" defaultValue={getValues(`share.${nestIndex}.nestedArray.${k}.startDate`)} className={!isEditing?.[nestIndex+k] ? "grey" : ""} />
                                    }
                                </Form.Group>
                            </Col>
                            <Col md={5} xs={12} lg={4} xl={isEditing?.[nestIndex+k] ? 3 :2}> 
                                <Form.Group as={Col} controlId="endDate">
                                    <Form.Label className="smallTitle">End Duration <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                    {isEditing?.[nestIndex+k] ?(
                                        <LocalizationProvider dateAdapter={AdapterDayjs} disabled={!isEditing?.[nestIndex+k]} sx={{"&.MuiStack-root": { paddingTop: "0 !important"}}}>
                                                <DemoContainer components={['DatePicker']} sx={{"& .MuiTextField-root": { minWidth: "130px !important"}, 
                                                "&.MuiStack-root": { paddingTop: "0 !important", overflow:"hidden" }}}>
                                                    <Controller
                                                        control={control}
                                                        name={`share.${nestIndex}.nestedArray.${k}.endDate`}
                                                        {...register(`share.${nestIndex}.nestedArray.${k}.endDate`, { required: true 
                                                        })}
                                                        render={({ field }) => (
                                                            <DatePicker
                                                                slotProps={{
                                                                    textField: {
                                                                        readOnly: true,
                                                                    },
                                                                }}
                                                                name={`share.${nestIndex}.nestedArray.${k}.endDate`}
                                                                views={getValues(`share.${nestIndex}.nestedArray.${k}.type`) == 1 ? ['month','day','year'] : ['month', 'year']}
                                                                refs={register(`share.${nestIndex}.nestedArray.${k}.endDate`, { required: true })}
                                                                minDate = {dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.minDate`))}
                                                                maxDate = {dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.maxDate`))}   
                                                                disabled= {getValues(`share.${nestIndex}.nestedArray.${k}.type`) ==1} 
                                                                defaultValue={getValues(`share.${nestIndex}.nestedArray.${k}.type`) ==1 ? dayjs()  : dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.endDate`)).endOf('month')}
                                                                value={getValues(`share.${nestIndex}.nestedArray.${k}.type`) ==1 ? dayjs() : dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.endDate`)).endOf('month')}
                                                                onChange={(date) => {
                                                                    field.onChange(dayjs(date).format("MM/DD/YYYY"));
                                                                    if (getValues(`share.${nestIndex}.nestedArray.${k}.type`) == 1) {
                                                                        const currentDate = new Date();
                                                                        setValue(`share.${nestIndex}.nestedArray.${k}.startDate`,dayjs(currentDate).format("MM/DD/YYYY"));
                                                                        setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,dayjs(currentDate).format("MM/DD/YYYY"));
                                                                        // setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,dayjs(date).format("MM/DD/YYYY"));
                                                                    } else {
                                                                        setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,dayjs(date).endOf('month').format("MM/DD/YYYY"));
                                                                    }
                                                                    // setValue(`share.${nestIndex}.nestedArray.${k}.endDate`,getValues(`share.${nestIndex}.nestedArray.${k}.type`) ==1 ? dayjs(date).format("MM/DD/YYYY") : dayjs(date).endOf('month').format("MM/DD/YYYY"));
                                                                }}
                                                                selected={field.value}
                                                                sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { padding:"9.5px 12px !important" }}}
                                                            />
                                                        )}
                                                    />
                                                </DemoContainer>
                                        </LocalizationProvider> ) : 
                                        <Form.Control type="text" defaultValue={getValues(`share.${nestIndex}.nestedArray.${k}.type`) ==1 ? getValues(`share.${nestIndex}.nestedArray.${k}.startDate`) : (dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.endDate`)) < dayjs(getValues(`share.${nestIndex}.nestedArray.${k}.startDate`)) ? getValues(`share.${nestIndex}.nestedArray.${k}.startDate`) : getValues(`share.${nestIndex}.nestedArray.${k}.endDate`))} className={!isEditing?.[nestIndex+k] ? "grey" : ""} />
                                    }
                                </Form.Group>
                            </Col>
                            <Col md={4} xl={2}>
                                <Form.Group>
                                    <Form.Label className="smallTitle"></Form.Label>
                                    <div>
                                        {!isEditing?.[nestIndex+k] && <EditIcon className="cursor-pointer"   titleAccess="edit" onClick={(e)=>onChangeEdit(e,item,k,false)}>{isEditing?.[nestIndex+k] ? 'Editing...' : 'Edit'}</EditIcon> }&nbsp;
                                        {isEditing?.[nestIndex+k] && <><SaveIcon className="cursor-pointer" titleAccess="save" onClick={(e)=> onChangeSave(e,item,k)}/>
                                        <DoDisturbIcon className="cursor-pointer" titleAccess="cancel" onClick={(e)=> {
                                            onChangeEdit(e,item,k,true);
                                            setIsShareRowEdit();
                                            setIsError(isDaily ? true : false);
                                            }} /> </>} &nbsp;&nbsp;                                 
                                        {  getValues(`share.${nestIndex}.nestedArray.${k}.type`) != 1 ?     //!getValues(`share.${nestIndex}.nestedArray.${k}.isDisableMonth`)? 
                                        <>
                                            <AddCircleIcon className="cursor-pointer" titleAccess="add" type="button" onClick={() =>{
                                               appendShare(item);
                                               dailyShareValidation(item);
                                           
                                                }
                                            } />&nbsp;
                                        </> : "" }
                                            { k != 0 ? <RemoveCircleOutlineIcon className="cursor-pointer" titleAccess="remove" type="button" onClick={() => { 
                                                remove(k);
                                                triggerPrecal({id: item.shareId});
                                                setIsShareRowEdit();
                                                setIsError(isDaily ? true : false);
                                                setIsEditing(false);
                                                dailyShareValidation(item);
                                            }} /> : ""}
                                         
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                );
            })}
        </Box>

    );
};

ShareNestedFieldArray.propTypes = {
    nestIndex: PropTypes.number.isRequired,
    control: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    shareInfo: PropTypes.object.isRequired,
    getValues:PropTypes.func,
    setValue: PropTypes.func,
    watch: PropTypes.func,
    setPreCalc: PropTypes.func,
    setIsShareRowEdit: PropTypes.func,
    triggerPrecal: PropTypes.func,
    setIsDaily: PropTypes.bool,
    isDaily:PropTypes.bool
}

export default ShareNestedFieldArray;
